var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AboutDirectSchool',{attrs:{"title":_vm.title,"locations":_vm.locations,"people":_vm.people}})}
var staticRenderFns = []

export { render, staticRenderFns }